var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { decl } from '@yandex-lego/i-bem-react';
import "./../dropdown2/dropdown2.react.js";
import _dropdown2_switcher_link from "./../dropdown2/_switcher/dropdown2_switcher_link.react.js";

var Dropdown = _dropdown2_switcher_link.applyDecls();

import "./../dropdown2/dropdown2.css";
import "./../menu/menu.react.js";
import "./../../desktop.blocks/menu/menu.react.js";
import _menu_type_navigation from "./../menu/_type/menu_type_navigation.react.js";

var Menu = _menu_type_navigation.applyDecls();

import "./../menu/menu.css";
import _icon from "./../icon/icon.react.js";

var Icon = _icon.applyDecls();

import "./../icon/icon.css";
import "./../link/link.react.js";
import "./../link/_pseudo/link_pseudo_yes.react.js";
import "./../link/link.css";
import "./../../desktop.blocks/link/link.css";
import "./../link/_theme/link_theme_pseudo.css";
import "./../../deskpad.blocks/link/_theme/link_theme_pseudo.css";
import "./../../desktop.blocks/link/_theme/link_theme_pseudo.css";
import _langSwitcher__lang from "./__lang/lang-switcher__lang.react.js";

var Lang = _langSwitcher__lang.applyDecls();

import "./__lang/lang-switcher__lang.css";
import _langSwitcher__langName from "./__lang-name/lang-switcher__lang-name.react.js";

var LangName = _langSwitcher__langName.applyDecls();

import "./__lang-name/lang-switcher__lang-name.css";
import "./__all/lang-switcher__all.css";
import "./../popup2/popup2.react.js";
import "./../popup2/_theme/popup2_theme_normal.react.js";
import "./../popup2/popup2.css";
import "./../popup2/_theme/popup2_theme_normal.css";
import "./../menu/menu.react.js";
import "./../../desktop.blocks/menu/menu.react.js";
import "./../menu/menu.css";
import "./../menu/_theme/menu_theme_normal.css";
import "./../menu/_size/menu_size_m.css";
import "./../menu/_size/menu_size_s.css";
import "./../country-flag/country-flag.css";
import "./../country-flag/_s16/country-flag_s16_by.css";
import "./../country-flag/_s16/country-flag_s16_gb.css";
import "./../country-flag/_s16/country-flag_s16_kz.css";
import "./../country-flag/_s16/country-flag_s16_ru.css";
import "./../country-flag/_s16/country-flag_s16_tr.css";
import "./../country-flag/_s16/country-flag_s16_tt.css";
import "./../country-flag/_s16/country-flag_s16_ua.css";

var i18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./lang-switcher.i18n/ru'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./lang-switcher.i18n/en'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./lang-switcher.i18n/be'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./lang-switcher.i18n/id'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./lang-switcher.i18n/kk'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./lang-switcher.i18n/tr'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./lang-switcher.i18n/tt'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./lang-switcher.i18n/uk'))('lang-switcher');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uz' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uz' : 'en' === 'uz') {
        return core().decl(require('./lang-switcher.i18n/uz'))('lang-switcher');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
    }

    return function () {};
}();

export default decl({
    block: 'lang-switcher',
    render: function render() {
        var _props = this.props,
            name = _props.name,
            lang = _props.lang;

        if (lang && lang.lang && lang.name) {
            name = lang.name;
            lang = lang.lang;
        }

        var block = this.block,
            _props2 = this.props,
            theme = _props2.theme,
            size = _props2.size,
            secretKey = _props2.secretKey,
            noflags = _props2.noflags,
            tld = _props2.tld,
            nomore = _props2.nomore,
            moreText = _props2.moreText;

        var tune = this.props.tune.replace('{tld}', tld);
        var setLangUrl = this.props.setLangUrl.replace('{tld}', tld);
        var retpath = encodeURIComponent(this.props.retpath || '');
        var allUrl = tune + '/lang' + (retpath && this.props.moreRetpath ? '?retpath=' + retpath : '');
        var baseUrl = setLangUrl;

        var children = Children.map(this.props.children, function (item, i) {
            if (!Lang.isLang(item)) {
                return item;
            }

            var _item$props = item.props,
                lang = _item$props.lang,
                name = _item$props.name;

            if (lang && lang.lang && lang.name) {
                name = lang.name;
                lang = lang.lang;
            }
            var selected = item.props.selected;

            var url = selected ? undefined : item.url ? item.url : secretKey ? baseUrl + '?intl=' + lang + '&retpath=' + retpath + '&sk=' + secretKey : allUrl;

            return React.cloneElement(item, {
                lang: lang,
                name: name,
                url: url,
                noflags: noflags,
                flags: this.__self.flags
            });
        }, this);

        return React.createElement(
            Dropdown,
            _extends({ theme: theme, size: size }, { mix: { block: block }, switcher: 'link' }),
            React.createElement(
                Dropdown.Switcher,
                { pseudo: true, inner: true, mix: { block: block, elem: 'lang' },
                    url: baseUrl },
                noflags ? undefined : React.createElement(Icon, { mix: [{ block: 'country-flag', mods: { s16: this.__self.flags[lang] } }, { block: block, elem: 'flag' }], alt: '' }),
                React.createElement(
                    LangName,
                    null,
                    name
                )
            ),
            React.createElement(
                Dropdown.Popup,
                null,
                React.createElement(
                    Menu,
                    _extends({ nowrap: true, type: 'navigation' }, { theme: theme, size: size }),
                    children,
                    children.length < 4 && nomore !== true && React.createElement(
                        Menu.Item,
                        { url: allUrl, mix: { block: block, elem: 'all' } },
                        moreText || i18n('all')
                    )
                )
            )
        );
    }
}, {
    propTypes: {
        theme: PropTypes.string,
        size: PropTypes.string,
        lang: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        name: PropTypes.string,
        retpath: PropTypes.string,
        tld: PropTypes.string,
        tune: PropTypes.string,
        setLangUrl: PropTypes.string,
        secretKey: PropTypes.string,
        noflags: PropTypes.bool,
        nomore: PropTypes.bool,
        moreText: PropTypes.string
    },
    defaultProps: {
        theme: 'normal',
        size: 'm',
        tld: 'ru',
        tune: 'https://yandex.{tld}/tune',
        setLangUrl: 'https://www.yandex.{tld}/portal/set/lang/'
    },
    flags: {
        be: 'by',
        en: 'gb',
        kk: 'kz',
        ru: 'ru',
        tr: 'tr',
        tt: 'tt',
        uk: 'ua'
    },
    Lang: Lang
});